import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeGetBasicLabelInfoByIdSelector } from "~/store/selectors/selector.labels.jsx";
import SimpleLabel from "./component.simple_label.jsx";

const SimpleLabelContainer = ({ id, as }) => {
  const getTaskLabelById = useMemo(makeGetBasicLabelInfoByIdSelector, []);
  const { name, color } = useSelector((state) => getTaskLabelById(state, id));

  if (!name || !color) return null;
  return (
    <SimpleLabel
      name={name}
      color={color}
      as={as}
    />
  );
};

SimpleLabelContainer.propTypes = {
  id: PropTypes.number.isRequired,
  as: PropTypes.oneOf(["item", "box", "dot"]),
};

export default SimpleLabelContainer;
